import moment from "moment";
import React, { useState } from "react";
import Alert from "../../../controls/Alert";

const TripLegReturnToStandValidator = (props) => {
  const record = props.record;

  const [state, setState] = useState({
    error: null,
    errorMessage: null
  }); 

  let error = false;
  let errorMessage = "";

  if (!error && !record.category) {
    error = true;
    errorMessage = "A 'Category' is required";
  }
  if (!error && (!record.returnTime || !moment(record.returnTime).isValid())) {
    error = true;
    errorMessage = "A 'Return Time' is required";
  }
  if (!error && moment.utc(record.returnTime).isAfter(moment.utc())) {
    error = true;
    errorMessage = "The 'Return Time' must not be in the future.";
  }
  if (!error && moment.utc(record.returnTime).isBefore(moment.utc(record.bloff))) {
    error = true;
    errorMessage = "The 'Return Time' must not be prior to the blocks off time.";
  }
  if (!error && !record.noteText) {
    error = true;
    errorMessage = "A 'Reason' is required";
  }

  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage });
    if (props.onChange) {        
      props.onChange({ error, errorMessage });
    }
  }

  return (
    <Alert open={error} severity="error" message={errorMessage}/>
  );
}

export default TripLegReturnToStandValidator;
